import { Wizard } from '@patternfly/react-core';
import styled from 'styled-components';

Wizard.displayName = 'PFWizard';
export default styled(Wizard)`
  .pf-c-toolbar__content {
    padding: 0 !important;
  }
`;
